import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { jsxs, jsx } from 'react/jsx-runtime.js';
import RingButton from '@jetbrains/ring-ui/dist/button/button.js';
import cn from 'classnames';
import { ExternalLink } from '../ExternalLink/ExternalLink.js';
import '@babel/runtime/helpers/objectWithoutProperties';
import 'react';
import typographyStyles from '../Typography/Typography.module.css.js';
import styles from './Footer.module.css.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Footer = function Footer(props) {
  var buttons = props.buttons,
    className = props.className,
    links = props.links;
  var currentYear = new Date().getFullYear();
  return jsxs("footer", {
    className: cn(typographyStyles.text, styles.footer, className),
    children: [jsxs("section", {
      children: ["\xA9 2020\u2013", currentYear, " Qodana"]
    }), jsxs("section", {
      className: styles.rightBlock,
      children: [jsx("ul", {
        className: styles.links,
        children: links.map(function (link) {
          return jsx("li", {
            children: jsx(ExternalLink, _objectSpread(_objectSpread({
              href: link.href
            }, link.htmlProps), {}, {
              children: link.label
            }))
          }, "".concat(link.href, " - ").concat(link.label));
        })
      }), jsx("ul", {
        className: styles.buttons,
        children: buttons.map(function (btn) {
          return jsx("li", {
            children: jsx(RingButton, _objectSpread(_objectSpread({
              className: styles.button,
              disabled: btn.disabled,
              onClick: btn.onClick,
              text: true
            }, btn.htmlProps), {}, {
              children: btn.label
            }))
          }, "".concat(btn.label).concat(JSON.stringify(btn.htmlProps)));
        })
      })]
    })]
  });
};

export { Footer };
